import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AssessmentPage from 'on_web/components/shared/AssessmentPage/AssessmentPage';
import {
  Grid,
  Typography,
  Box,
  AppBar,
  Toolbar,
  Divider,
} from '@material-ui/core';
import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'on_web/components/shared/Common/Button';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import auth0Client from 'on_web/Auth0';
import { TRANSPARENT_WHITE } from 'colours';
import { getAppRedirectRoute } from 'on_web/helpers/redirectHelper';
import useUsersApi from 'on_web/hooks/useUsersApi';
import { Redirect } from 'react-router-dom';
import LandingItem from 'on_web/components/landing/LandingItem';
import {
  landingIllustration,
  landingIllustration01,
  landingIllustration02,
  hippa,
  gdpr,
  gina,
  ccpa,
} from 'on_web/assets/imageList';
import SwipeableViews from 'react-swipeable-views';
import MobileStepper from '@material-ui/core/MobileStepper';

export default function LandingAlternatePage(props) {
  const { t } = useTranslation();
  const [isDesktop, isMobile] = useCheckScreenSize();
  const [{ response, loading, getUserData }] = useUsersApi();
  const [activeStep, setActiveStep] = useState(0);

  const useStyles = makeStyles(theme => ({
    bar: {
      top: 'auto',
      bottom: 0,
      backgroundColor: TRANSPARENT_WHITE,
    },
    title: {
      paddingTop: '17px',
    },
    paragraph: {
      color: '#222222',
      textAlign: isDesktop ? 'left' : 'center',
      fontSize: isDesktop ? '18px' : '16px',
      lineHeight: '20px',
    },
    root: {
      maxWidth: 400,
      flexGrow: 1,
    },
  }));
  const classes = useStyles();

  useEffect(() => {
    trackEvent('Arrived at Landing', 'Landing page visited');
    if (window.localStorage.getItem('access_token')) {
      getUserData().catch(() => window.localStorage.removeItem('access_token'));
    } else if (window.localStorage.getItem('lncovidspareland1') != null) {
      // user isn't signed in, but it seems that it is returning user -> redirect user to Auth0
      auth0Client.signIn();
    }
  }, [getUserData]);

  const getGoToRoute = () => {
    const route = getAppRedirectRoute('spare', response.user_metadata);
    if (
      window &&
      window.location &&
      window.location.search &&
      window.location.search !== ''
    ) {
      return `${route}/${window.location.search}`;
    } else {
      return route;
    }
  };

  const renderButton = () => {
    return (
      <Button
        variant="contained"
        color="primary"
        backgroundGradient={'linear-gradient(to right, #194378, #30eaff)'}
        style={{
          textTransform: 'uppercase',
          fontSize: '13px',
          marginTop: '10px',
          marginBottom: '10px',

          paddingLeft: '40px',
          paddingRight: '40px',
          paddingTop: '10px',
          paddingBottom: '10px',
        }}
        onClick={() => {
          trackEvent('Passed Through Landing', 'Lets go clicked');
          auth0Client.signUp();
        }}
      >
        {t('landing.button')}
      </Button>
    );
  };

  const getLandingItems = () => {
    return [
      <LandingItem
        paragraphs={'landingAlternate.paragraph1'}
        illustration={landingIllustration01}
      />,
      <LandingItem
        paragraphs={'landingAlternate.paragraph2'}
        illustration={landingIllustration02}
      />,
      <LandingItem
        paragraphs={'landingAlternate.paragraph3'}
        illustration={landingIllustration}
      />,
    ];
  };

  if (response && response.user_metadata) {
    return <Redirect to={getGoToRoute()} />;
  } else if (
    window.location.href.indexOf('signin') !== -1 ||
    loading === false
  ) {
    return (
      <AssessmentPage noDesktopSupport={true} hideBottomNavigation={true}>
        {isDesktop === false && (
          <>
            <SwipeableViews onChangeIndex={ix => setActiveStep(ix)}>
              {getLandingItems().map((item, ix) => {
                return item;
              })}
            </SwipeableViews>
            <Box justifyContent="center" display="flex">
              <Box>
                <MobileStepper
                  variant="dots"
                  steps={3}
                  position="static"
                  activeStep={activeStep}
                  className={classes.root}
                />
              </Box>
            </Box>
          </>
        )}

        {isDesktop && (
          <div>
            <Grid container direction={'row'} justify={'center'}>
              <Grid item>
                <LandingItem
                  paragraphs={'landingAlternate.paragraph1'}
                  illustration={landingIllustration01}
                />
              </Grid>
              <Grid item>
                <LandingItem
                  paragraphs={'landingAlternate.paragraph2'}
                  illustration={landingIllustration02}
                />
              </Grid>
              <Grid item>
                <LandingItem
                  paragraphs={'landingAlternate.paragraph3'}
                  illustration={landingIllustration}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1} style={{ marginTop: '15px' }}>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center">
                  {renderButton()}
                </Box>
              </Grid>
            </Grid>
          </div>
        )}

        <Divider style={{ marginTop: '20px' }} />

        <Grid
          container
          direction={'column'}
          justify="center"
          style={{ marginBottom: isDesktop ? '20px' : '90px' }}
        >
          <Grid item xs={12}>
            <Box
              className={classes.title}
              display={'block'}
              textAlign={'center'}
              mx={2}
            >
              <Typography variant={'h2'}>
                {t('landingAlternate.safeguardTitle')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              className={classes.title}
              display={'block'}
              textAlign={'center'}
              mx={2}
            >
              <Typography
                variant={'body1'}
                className={classes.paragraph}
                style={{ textAlign: 'center' }}
              >
                {t('landingAlternate.safeguardParagraph')}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} style={{ marginTop: '20px' }}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item>
                <img
                  src={hippa}
                  style={{ marginLeft: '5px', marginRight: '5px' }}
                />
              </Grid>
              <Grid item>
                <img
                  src={gdpr}
                  style={{ marginLeft: '5px', marginRight: '5px' }}
                />
              </Grid>
              <Grid item>
                <img
                  src={ccpa}
                  style={{ marginLeft: '5px', marginRight: '5px' }}
                />
              </Grid>
              <Grid item>
                <img
                  src={gina}
                  style={{ marginLeft: '5px', marginRight: '5px' }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {isDesktop === false && (
          <AppBar
            position="fixed"
            color="transparent"
            elevation={0}
            className={classes.bar}
          >
            <Toolbar>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Box display="flex" justifyContent="center">
                    {renderButton()}
                  </Box>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
        )}
      </AssessmentPage>
    );
  } else {
    return <></>;
  }
}
